import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';

export default function ThemeToggle() {
  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('theme') || 'light';
    }
    return 'light';
  });

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
  };

  useEffect(() => {
    const root = window.document.documentElement;
    
    // Remove the previous theme class and add the new one
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
    
    // Update localStorage
    localStorage.setItem('theme', theme);
  }, [theme]);

  return (
    <button
      onClick={toggleTheme}
      aria-label="Toggle dark mode"
      className="relative inline-flex h-[38px] w-[74px] shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 dark:bg-gray-700 transition-colors duration-300 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-[#8f00ff] focus-visible:ring-opacity-75"
    >
      <span
        aria-hidden="true"
        className={`
          pointer-events-none inline-block h-[34px] w-[34px] transform rounded-full bg-white shadow-lg ring-0 transition duration-300 ease-in-out flex items-center justify-center
          ${theme === 'dark' ? 'translate-x-9 bg-gray-900' : 'translate-x-0'}
        `}
      >
        <FontAwesomeIcon 
          icon={theme === 'dark' ? faMoon : faSun}
          className={`h-4 w-4 ${theme === 'dark' ? 'text-[#ffd700]' : 'text-[#8f00ff]'}`}
        />
      </span>
    </button>
  );
} 